/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./ColumnGrid.css";
import cross from "../../../images/Cross.svg";
import plus from "../../../images/Plus.svg";

import React from "react";

import { ColumnGridProps, ColumnGridState } from "./ColumnGrid.types";

export default class ColumnGrid extends React.Component<ColumnGridProps, ColumnGridState> {

   private componentClassName: string;

   constructor(props: ColumnGridProps) {

      super(props);

      this.componentClassName = "tk-column-grid" + (this.props.componentName ? `-${this.props.componentName}` : "");

      this.state = {};
   }

   public componentDidMount() {
   }

   public componentWillUnmount() {
   }

   public render(): React.ReactNode {

      let hasItems = false;
      this.props.columns.forEach(c => hasItems = hasItems || c.items.length > 0 )

      const columns = !hasItems || this.props.isLoading ?

         this.props.isLoading ?
            <div className="spinner"></div>
         :
            <></>
      :
         this.props.columns.map(

            (column, columnIndex) => {

               const items = column.items.map(

                  (item) => {

                     if (!item || !item.id || !item.data) return undefined;

                     const addButton = this.props.plusIcon ? <img className="item-button" src={plus} alt="+" onClick={(e) => { this.onPlusIconClick(e, columnIndex, item.id); }} /> : null;
                     const removeButton = this.props.crossIcon ? <img className="item-button" src={cross} alt="x" onClick={(e) => { this.onCrossIconClick(e, columnIndex, item.id); }} /> : null;

                     return (
                        <div key={item.id} className="item" data-selectable={this.props.selectableItems} onDoubleClick={(e) => { this.onItemDblClick(e, columnIndex, item.id) }} onMouseDown={this.preventDblClickSelect}>
                           {item.data}
                           <div className="item-buttons">
                              {removeButton}
                              {addButton}
                           </div>
                        </div>
                     )

                  }

               )

               return (
                  <div key={column.label} className="column">
                     <div className="column-label">{column.label}</div>
                     {items}
                  </div>
               )


            }
         )

      return (
         <div className={this.componentClassName}>
            {columns}
         </div>
      )

   }


   private preventDblClickSelect = (e: React.MouseEvent) => {
      if (e.detail > 1) e.preventDefault();
   }

   private onPlusIconClick = (e: React.MouseEvent, columnIndex: number, itemId: string) => {

      if (this.props.onPlusIconClick) {
         if (this.props.onPlusIconClick) this.props.onPlusIconClick(columnIndex, itemId);
         window.getSelection()?.removeAllRanges();
      }

   }

   private onCrossIconClick = (e: React.MouseEvent, columnIndex: number, itemId: string) => {

      if (this.props.onCrossIconClick) {
         if (this.props.onCrossIconClick) this.props.onCrossIconClick(columnIndex, itemId);
         window.getSelection()?.removeAllRanges();
      }

   }

   private onItemDblClick = (e: React.MouseEvent, columnIndex: number, itemId: string) => {

      if (this.props.onItemDblClick) {
         if (this.props.onItemDblClick) this.props.onItemDblClick(columnIndex, itemId);
         window.getSelection()?.removeAllRanges();
      }

   }


}
